import React from "react";
import SeoPage from "../../components/SeoPage";
import RELATED from "../../data/related";
import { faqsByTopic } from "../../data/faqs";

export default function Features() {
    return (
        <SeoPage
            title="Features — Everything OpenCSV Does"
            description="Open, edit, search, save, share, and sync CSV files. The complete OpenCSV feature list — what's in v1, what's coming next."
            breadcrumbs={[{ label: "Home", href: "/" }, { label: "Features" }]}
            eyebrow="/ overview"
            h1="What OpenCSV does"
            heroLead="OpenCSV is intentionally small. Here's everything in v1 — and what we're working on next."
            sections={[
                { heading: "Viewing",
                    bullets: [
                        "Open .csv files via drag-and-drop or file picker",
                        "Auto-detect headers, comma delimiter, UTF-8 encoding",
                        "Streaming parser handles 100,000+ row files smoothly",
                        "Virtualised table renders only visible rows for speed",
                        "Mobile-friendly with horizontal scroll on small screens",
                    ],
                },
                { heading: "Editing",
                    bullets: [
                        "Inline cell editing — click any cell, type, save",
                        "Add or delete rows with one click",
                        "Add or delete columns with auto-named headers",
                        "Edit column headers inline",
                        "Real-time search across every cell",
                    ],
                },
                { heading: "Saving & sharing",
                    bullets: [
                        "Download edited CSV to your device (clean, properly-escaped)",
                        "Save to private cloud library (paid users)",
                        "Open cloud-saved files from any device",
                        "Generate read-only public share links per file",
                        "Revoke share links any time",
                    ],
                },
                { heading: "Account & access",
                    bullets: [
                        "Email + password sign in (with secure brute-force protection)",
                        "Google OAuth (one-click sign in)",
                        "$9.99/month or $79/year — 14-day free trial, no card",
                        "Same login works across web, iOS, Android",
                    ],
                },
                { heading: "Privacy",
                    bullets: [
                        "Files load and edit locally in your browser",
                        "No analytics tracking on file content",
                        "No advertising or third-party trackers",
                        "Single httpOnly auth cookie",
                        "Cloud save is opt-in only",
                    ],
                },
                { heading: "What's coming next",
                    body: "Items on the public roadmap, in rough priority order:",
                    bullets: [
                        "Native iOS and Android apps (with In-App Purchase unlock)",
                        "Delimiter selector (tab, semicolon, pipe)",
                        "Encoding selector (UTF-8, ANSI, ISO-8859-1)",
                        "Column type assignment (number, currency, date, email)",
                        "Deduplication tool",
                        "CSV diff between two files",
                    ],
                    callout: "Some of these may live in higher-tier subscriptions in the future. Your current Pro plan stays included for everything in this list above."
                },
            ]}
            faqs={faqsByTopic("general", "edit", "open", "share", "pricing", "devices")}
            related={[RELATED.viewer, RELATED.editor, RELATED.light, RELATED.privacy, RELATED.fast, RELATED.faq]}
        />
    );
}
